const editable = ['forma_pagamento_id','data_matricula','data_vencimento','vencimento','valor','data_pagamento','data_recebimento','observacoes','cheque_numero'];
const normalize = (key,value) => value == null || value === '' ? null : ['valor','forma_pagamento_id'].includes(key) ? Number(value) : key.startsWith('data_') || key === 'vencimento' ? String(value).slice(0,10) : value;
export function paymentPatch(original, candidate) {
  const patch = {};
  for (const key of editable) {
    if (!Object.prototype.hasOwnProperty.call(original || {},key) || !Object.prototype.hasOwnProperty.call(candidate,key)) continue;
    if (normalize(key,original[key]) !== normalize(key,candidate[key])) patch[key] = candidate[key];
  }
  if (candidate.conta_financeira_id != null && candidate.conta_financeira_id !== '' &&
      Number(candidate.conta_financeira_id) !== Number(original?.conta_financeira_id)) {
    patch.conta_financeira_id = Number(candidate.conta_financeira_id);
  }
  return patch;
}
export function operationalPayment(row, candidate, dueKey = 'data_vencimento') {
  const result = { id: row.id };
  for (const key of ['forma_pagamento_id','valor',dueKey,'data_pagamento','data_recebimento','cheque_numero']) {
    if (Object.prototype.hasOwnProperty.call(row,key) && Object.prototype.hasOwnProperty.call(candidate,key)) result[key]=candidate[key];
  }
  return result;
}

export function paymentCollectionOperations(original, candidates, dueKey = 'data_vencimento', { operationalAccountSelection = false } = {}) {
  const byId = new Map(original.map(row => [Number(row.id), row]));
  const retained = new Set();
  const pagamentos = [], adicionar_pagamentos = [];
  for (const candidate of candidates) {
    const row = byId.get(Number(candidate.id));
    if (row) {
      retained.add(Number(row.id));
      const patch = operationalPayment(row,candidate,dueKey);
      if (operationalAccountSelection && !row.data_pagamento && !row.data_recebimento && !row.pago &&
          candidate.data_pagamento && candidate.conta_financeira_id != null && candidate.conta_financeira_id !== '') {
        patch.conta_financeira_id = Number(candidate.conta_financeira_id);
      }
      for (const key of ['banco_numero','agencia','conta_financeira_id','numero_autorizacao','observacoes','pago']) {
        if (Object.prototype.hasOwnProperty.call(row,key) && Object.prototype.hasOwnProperty.call(candidate,key) && normalize(key,row[key]) !== normalize(key,candidate[key])) patch[key]=candidate[key];
      }
      pagamentos.push(patch);
    } else {
      if (candidate.id != null) throw new Error('Identidade de parcela desconhecida. Recarregue o formulário.');
      const added={};
      for (const key of ['forma_pagamento_id','valor',dueKey,'data_pagamento','data_recebimento','cheque_numero','pago','banco_numero','agencia','conta_financeira_id','numero_autorizacao','observacoes']) if (Object.prototype.hasOwnProperty.call(candidate,key)) added[key]=candidate[key];
      adicionar_pagamentos.push(added);
    }
  }
  return {pagamentos, adicionar_pagamentos, remover_pagamentos_ids:original.filter(row=>!retained.has(Number(row.id))).map(row=>row.id)};
}
